import React, { Component } from 'react';
import { List, Datagrid, TextField, EditButton } from 'react-admin';

export default class ZonesInterestList extends Component {
    render() {
        return (
            <List {...this.props} title="Listado de zonas de interes">
                <Datagrid>
                    <TextField source="name" label="Nombre" />
                    <EditButton label="" />
                </Datagrid>
            </List>
        )
    }
};